import React, { createContext, useContext, ReactNode, useState } from 'react'
import { SurfaceObsSensors } from '../../utils/SurfaceObsUtils'
import useTWSMapContext from '../../hooks/UseTWSContext'
import SlideOverDialog from './SlideOverDialog'
import { MenuLabels } from '../../constants/MenuLabels'

interface SlideOverDialogContextType {
  totalProducts: string[]
  setProductVisibility: string[]
  addProductVisibility: (productName: string) => void
  removeProductVisibility: (productName: string) => void
  setTotalProducts: React.Dispatch<React.SetStateAction<string[]>>
  setProductFilter: (products: string[]) => void
}

export const SlideOverDialogContext = createContext<
  SlideOverDialogContextType | undefined
>(undefined)

export function SlideOverDialogProvider({ children }: { children: ReactNode }) {
  const [setProductVisibility, setSetProductVisibility] =
    useState<string[]>(SurfaceObsSensors)
  const [totalProducts, setTotalProducts] =
    useState<string[]>(SurfaceObsSensors)
  // let totalProducts: string[] = []

  const addProductVisibility = (productName: string) => {
    setSetProductVisibility((prevVisibility) => [
      ...prevVisibility,
      productName,
    ])
  }

  const removeProductVisibility = (productName: string) => {
    setSetProductVisibility((prevVisibility) =>
      prevVisibility.filter((product) => product !== productName)
    )
  }

  const setProductFilter = (products: string[]) => {
    if (products.length) {
      setTotalProducts([...products])
    }
  }

  return (
    <SlideOverDialogContext.Provider
      value={{
        totalProducts,
        setProductVisibility,
        addProductVisibility,
        removeProductVisibility,
        setTotalProducts,
        setProductFilter,
      }}
    >
      {children}
    </SlideOverDialogContext.Provider>
  )
}

export function useSlideOverDialogContext() {
  const context = useContext(SlideOverDialogContext)
  if (!context) {
    throw new Error(
      'useSlideOverDialogContext must be used within a SlideOverDialogProvider'
    )
  }
  return context
}
